module.exports = __webpack_public_path__ + "static/media/Frame 2821.dd5b1aad.jpg";